import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

//components
import { InputText } from 'primereact/inputtext';     
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

//api
import AuthenticationService from '../../../../service/authentication-service';
import { storeSet} from '../../../../store';


const LoginForm = ()=>{
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    // eslint-disable-next-line no-unused-vars
    const [error,setError]= useState('');


    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        setError('');

        const loginRequest = {
            username: username,
            password: password
        }

        AuthenticationService.login( loginRequest, (response)=>{
            const token = response.token;
            if(token){
                storeSet('token',token);
                localStorage.setItem('token',token);
                navigate("/dashboard/home");
            } else {
                setError('Token non trovato');
            }
        },
        (error)=>{
            console.error('Errore durante il login', error);
            setError('Username o password errati');
        }
    )
    }

    return (
        <div>
            <form  onSubmit={handleLogin}>
            <div className="LoginForm__InputWrapper">
            <label htmlFor="username">Username</label>
                <InputText 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                />
            </div>
            <div className="LoginForm__InputWrapper">
            <label htmlFor="username">Password</label>
                <Password 
                value={password} 
                onChange={(e) => setPassword(e.target.value)}/>
            </div>
            <Button className='LoginForm_Button'
                label="Accedi" style={{marginTop:'4rem'}}
            />
        </form>
        </div>
        
    )
}

export default LoginForm